 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/titlepage'
 import CONTENTS from '@/components/contents'
 import COPYRIGHT from '@/components/copyright'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import INTRODUCTION from '@/components/introduction'
 import GLOSSARYOFTERMS from '@/components/glossaryofterms'
 import CHAPTER001 from '@/components/chapter001'
 import JLWOODSON from '@/components/jlwoodson'
 import NALEIGHNAKAI from '@/components/naleighnakai'
 import CHAPTER002 from '@/components/chapter002'
 import MARYBMORRISON from '@/components/marybmorrison'
 import CHAPTER003 from '@/components/chapter003'
 import STEPHANIEMFREEMAN from '@/components/stephaniemfreeman'
 import CHAPTER004 from '@/components/chapter004'
 import EHRYCKGILMORECH from '@/components/ehryckgilmorech'
 import CHAPTER005 from '@/components/chapter005'
 import LAAMMITAI from '@/components/laammitai'
 import CHAPTER006 from '@/components/chapter006'
 import DARRYLBENALLY from '@/components/darrylbenally'
 import CHAPTER007 from '@/components/chapter007'
 import MATTSANDY from '@/components/mattsandy'
 import CHAPTER008 from '@/components/chapter008'
 import CHILOVE from '@/components/chilove'
 import CHAPTER009 from '@/components/chapter009'
 import JEREMYBURRIGHT from '@/components/jeremyburright'
 import CHAPTER010 from '@/components/chapter010'
 import JACQUIEBRANAGAN from '@/components/jacquiebranagan'
 import CHAPTER011 from '@/components/chapter011'
 import BOBBYDELRIO from '@/components/bobbydelrio'
 import CHAPTER012 from '@/components/chapter012'
 import SIRMARCOROBINSON from '@/components/sirmarcorobinson'
 import CHAPTER013 from '@/components/chapter013'
 import DANEISEN from '@/components/daneisen'
 import CHAPTER014 from '@/components/chapter014'
 import GLENNRUDIN from '@/components/glennrudin'
 import CHAPTER015 from '@/components/chapter015'
 import HEALTHUNICORNMIKE from '@/components/healthunicornmike'
 import CHAPTER016 from '@/components/chapter016'
 import THEWRITESTUFF from '@/components/thewritestuff'
 import THEBLUEPRINTFORWRITINGPUBLISHING from '@/components/theblueprintforwritingpublishing'
 import THEMARKETINGSTUFF from '@/components/themarketingstuff'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js